module.exports = __webpack_public_path__ + "img/TZS09448.72b41f2c.jpeg";